
import MarketAnalysisFAQ from "@/components/marketAnalysis/MarketAnalysisFAQ";
import MarketSummaryCard from "@/components/marketAnalysis/MarketSummaryCard";
import ReportSubscriptionBanner from "@/components/marketAnalysis/ReportSubscriptionBanner";
import ReportSubscriptionModal from "@/components/marketAnalysis/ReportSubscriptionModal";
import MarketAnalysisService from "@/service//MarketAnalysisService";
import AuthService from '@/service/AuthService';

export default {
    name: 'DailyReportSection',

    components: {
        MarketSummaryCard,
        MarketAnalysisFAQ,
        ReportSubscriptionBanner,
        ReportSubscriptionModal,
    },

    props: {
        isArchiveMarketPage: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            isReportLoading: false,
            marketSummaryContent: null,
            marketSummaryCreatedAt: '',
            isReportSubscriptionModalOpened: false,
            generalReportSubscriptionActive: null,
            generalReportSubscriptionFrequency: null,
            personalizedReportSubscriptionActive: null,
            personalizedReportSubscriptionFrequency: null,
        }
    },

    async fetch() {
        this.isReportLoading = true
        let locale = this.$getFallbackLocale()
        const routeLang = this.$route.path.split('/')?.[1];
        if (this.$getAvailableLocaleCodes().includes(routeLang)) {
            locale = routeLang
        }

        this.$setLocale(locale)

        try {
            const dateOnUrl = this.$route.params.date
            const res = dateOnUrl ?
                await this.marketAnalysisService.getMarketSummaryByDate(dateOnUrl, locale) :
                await this.marketAnalysisService.getLastMarketSummary(locale)

            if (res.body) {
                this.marketSummaryContent = res.body
                this.marketSummaryCreatedAt = res.created
            } else {
                this.marketSummaryContent = null
                this.marketSummaryCreatedAt = ''
            }
            this.isReportLoading = false
        } catch (error) {            
            this.marketSummaryContent = null
            this.marketSummaryCreatedAt = ''
            this.isReportLoading = false
        }
    },

    computed: {
        isLoggedIn() {
            return !!this.$store.state.account.user
        },
        subscriptionFrequency() {
            return this.generalReportSubscriptionActive ? this.generalReportSubscriptionFrequency : null;
        }
    },

    watch: {
        isLoggedIn: {
            handler(value) {
                if (!value) {
                    return;
                }

                this.fetchGeneralReportSubscriptionActive();
                this.fetchGeneralReportSubscriptionFrequency();
            },
            immediate: true
        },
    },

    created() {
        this.marketAnalysisService = new MarketAnalysisService(this.$axios);
    },

    methods: {
        openReportSubscriptionModal() {
            this.isReportSubscriptionModalOpened = true;
        },
        async fetchGeneralReportSubscriptionActive() {
            try {
                this.generalReportSubscriptionActive = await AuthService.getGeneralReportSubscriptionActive(this.$axios);
            } catch (error) {
                this.generalReportSubscriptionActive = null;
            }
        },
        async fetchGeneralReportSubscriptionFrequency() {
            try {
                this.generalReportSubscriptionFrequency = await AuthService.getGeneralReportSubscriptionFrequency(this.$axios);
            } catch (error) {
                this.generalReportSubscriptionFrequency = null;
            }
        },
        updateReportActive(value) {
            this.generalReportSubscriptionActive = value;
        },
        updateReportFrequency(value) {
            this.generalReportSubscriptionFrequency = value;
        }
    }
    
}
